/**
 * This is a presentation file.  Place all
 * code which calls, modifies or data in
 * a corresponding JSX Container File.
 */
import React, { Component } from 'react';
import ReactHighcharts from '../CommonComponents/Highcharts';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Text } from '../CommonComponents/OPL/Text/Text';

const BREAKDOWN_SCHEMAS = {
  Assets: {
    groups: 'AssetGroups',
    name: 'AssetGroup',
    balance: 'AssetGroupBalance',
  },
  Liabilities: {
    groups: 'LiabilityGroups',
    name: 'LiabilityGroup',
    balance: 'LiabilityGroupBalance',
  },
};

const isInitialized = state => {
  const CHART_TYPE = 'chart_type',
    hasChartType = state.hasOwnProperty(CHART_TYPE),
    hasChart =
      hasChartType && state.hasOwnProperty(state[CHART_TYPE]) && !!state[state[CHART_TYPE]];

  if (hasChart) {
    return state[state[CHART_TYPE]].is_initialized;
  }
  return false;
};
class NetWorthDonutChartView extends Component {
  componentDidMount() {
    this.triggerResize();
  }

  componentDidUpdate() {
    this.triggerResize();
  }

  triggerResize() {
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  }

  render() {
    let { chart_data, chart_type, chartTotal, breakdown, expanded } = this.props,
      is_initialized = isInitialized(this.props);
    if (is_initialized && chart_data) {
      if (Object.keys(chart_data).length > 0) {
        if (!chart_data.hide_chart) {
          return (
            <section className="accounts_chart chart NetWorthDonutChart">
              <div className="donut-chart-container">
                <div id={`nwdc_${chart_type}`}>
                  <ReactHighcharts container={`nwdc_${chart_type}`} options={chart_data} />
                </div>
                <div className="TotalLabel" data-content={chart_type}>
                  <span>
                    <i className="sup">$</i>
                    {ADV.util.number_format(chartTotal)}
                  </span>
                </div>
              </div>
              {expanded ? (
                <Box as="ul" css="list-style: none" px="32" py="0">
                  <Box
                    as="li"
                    borderBottom="1px solid"
                    borderColor="neutral.500"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Text fontWeight={600}>{chart_type}</Text>

                    <Text
                      fontWeight={600}
                      color={chart_type === 'Liabilities' ? 'error.500' : 'primary.500'}
                      variant="tabular"
                    >
                      <i>$</i>
                      {ADV.util.number_format(chartTotal)}
                    </Text>
                  </Box>

                  {!!breakdown &&
                    breakdown.hasOwnProperty(chart_type) &&
                    BREAKDOWN_SCHEMAS.hasOwnProperty(chart_type) &&
                    breakdown[chart_type][BREAKDOWN_SCHEMAS[chart_type].groups].map((group, i) => {
                      return (
                        <Box
                          as="li"
                          key={`${i}-${group[BREAKDOWN_SCHEMAS[chart_type].name]}`}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mt="16"
                        >
                          <Text>{group[BREAKDOWN_SCHEMAS[chart_type].name]}</Text>

                          <Text
                            color={chart_type === 'Liabilities' ? 'error.500' : 'primary.500'}
                            variant="tabular"
                          >
                            <i>$</i>
                            {ADV.util.number_format(group[BREAKDOWN_SCHEMAS[chart_type].balance])}
                          </Text>
                        </Box>
                      );
                    })}
                </Box>
              ) : null}
            </section>
          );
        } else {
          return null;
        }
      } else {
        return (
          <div id={`nwdc_${chart_type}`}>
            <div className="empty">
              <i className="fa fa-briefcase" />
              <p>No data available for {chart_type}.</p>
            </div>
          </div>
        );
      }
    }
    return null;
  }
}

export default NetWorthDonutChartView;
